import { memo } from 'react';

import { Search, X } from 'lucide-react';

import { DebouncedInput } from '@/components/TailwindComponents/components/Form/DebouncedInput/DebouncedInput';

export interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  debounceTime?: number;
}

const SearchInputComponent = ({
  placeholder,
  value,
  onChange,
  debounceTime = 300,
}: SearchInputProps) => {
  return (
    <div className="relative h-[40px] w-[340px] max-w-full sm:w-[240px]">
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <Search className="w-4 h-4 text-gray-500" />
      </div>
      <DebouncedInput
        debounceTime={debounceTime}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="flex rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm pl-10 pr-10 h-[40px] w-full"
      />
      {value?.length > 0 && value !== '' && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute inset-y-0 right-0 flex items-center pr-3 rounded-r-md z-20 cursor-pointer"
        >
          <X className="w-4 h-4 text-gray-500 hover:text-gray-700" />
        </button>
      )}
    </div>
  );
};

SearchInputComponent.displayName = 'SearchInput';

export const SearchInput = memo(SearchInputComponent);
